import { testimonials } from "../../../mocks/trendData";

const values = [
  { icon: "ri-time-line", title: "一事一链", desc: "每个话题都按时间顺序归档，关键节点保留出处，脉络可回溯。" },
  { icon: "ri-focus-3-line", title: "还原优先", desc: "尽力区分已核实信息与猜测，不把推测当结论，还原原始措辞。" },
  { icon: "ri-refresh-line", title: "持续跟进", desc: "连载事件不追一半就停，有新进展立刻补上，不错过任何后续。" },
  { icon: "ri-community-line", title: "一起吃瓜", desc: "欢迎投稿你正在追踪的话题，编辑部评估后帮你整理成完整时间线。" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-5">
          {/* 左：品牌介绍 */}
          <div className="rounded-2xl border border-background-200 bg-background-100 p-5 lg:col-span-2 md:p-7">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-quill-pen-line" aria-hidden="true"></i> 关于我们
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              把散落的瓜，串成一条线
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              吃瓜合集是一个专注娱乐热点与事件追踪的内容平台。我们观察到，很多"连续剧式"的话题
              往往在各大平台零散发酵，追着看很容易漏掉关键环节。于是我们把这些连载瓜、系列爆料
              按时间线统一整理，做成可一次看完的事件全记录。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们的目标很简单：老板吃瓜更省心。点开一个合集，就能顺着时间线看到事件从哪里开始、
              经历了哪些反转、现在进展到哪一步，不再被零碎消息牵着走。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-3">
              <div className="rounded-xl bg-background-50 p-4 text-center">
                <p className="font-heading text-2xl font-bold text-primary-600">1200+</p>
                <p className="mt-1 text-xs text-foreground-500">事件合集档案</p>
              </div>
              <div className="rounded-xl bg-background-50 p-4 text-center">
                <p className="font-heading text-2xl font-bold text-accent-600">860+</p>
                <p className="mt-1 text-xs text-foreground-500">连载瓜持续追更</p>
              </div>
            </div>
          </div>

          {/* 右：原则 + 口碑 */}
          <div className="flex flex-col gap-4 lg:col-span-3">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
              <h3 className="font-heading text-lg font-bold text-foreground-950">我们的内容原则</h3>
              <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {values.map((v) => (
                  <div key={v.title} className="flex gap-3 rounded-xl bg-background-100 p-4">
                    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-secondary-100 text-lg text-secondary-700">
                      <i className={v.icon} aria-hidden="true"></i>
                    </span>
                    <div>
                      <h4 className="text-sm font-bold text-foreground-950">{v.title}</h4>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6">
              <h3 className="font-heading text-lg font-bold text-foreground-950">他们这样说</h3>
              <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-3">
                {testimonials.map((t) => (
                  <figure key={t.name} className="flex flex-col rounded-xl bg-background-50 p-4">
                    <div className="flex gap-1 text-accent-400">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                      ))}
                    </div>
                    <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                      “{t.text}”
                    </blockquote>
                    <figcaption className="mt-3 flex items-center justify-between border-t border-background-200 pt-3">
                      <span className="text-sm font-semibold text-foreground-950">{t.name}</span>
                      <span className="text-xs text-foreground-400">{t.tag}</span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}